import React from 'react'
import { useEffect, useState } from 'react'
import { Container, Box, CircularProgress, Typography } from '@material-ui/core'
import axios from 'axios'
import queryString from 'query-string'

const ScopeCheckoutRedirect = () => {
  const [{ status, message }, setState] = useState({ status: 'loading', message: 'Preparing checkout…' })

  useEffect(() => {
    const { id, sk, base } = queryString.parse(window.location.search)

    if (!id || !sk) {
      setState({ status: 'error', message: 'Missing required parameters.' })
      return
    }

    const path = `/api/v1/stripe/checkout/redirect?json=true&id=${encodeURIComponent(id)}&sk=${encodeURIComponent(sk)}`
    const url = base ? `${String(base).replace(/\/$/, '')}${path}` : path

    const run = async () => {
      try {
        setState({ status: 'loading', message: 'Contacting checkout…' })
        const { data } = await axios.get(url, { timeout: 15000 })
        if (data && data.url) {
          setState({ status: 'redirect', message: 'Redirecting to Stripe…' })
          window.location.replace(data.url)
        } else {
          // If the backend decided to redirect (json was ignored), follow location
          setState({ status: 'error', message: 'Unexpected response from server.' })
        }
      } catch (e) {
        const code = e?.response?.status
        if (code === 409) {
          setState({ status: 'error', message: 'This order has already been completed.' })
        } else {
          setState({ status: 'error', message: 'Failed to create checkout session. Please try again later.' })
        }
      }
    }

    run()
  }, [])

  return (
    <Container maxWidth="sm">
      <Box
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        minHeight="60vh"
        textAlign="center"
      >
        {status === 'loading' || status === 'redirect' ? (
          <>
            <CircularProgress />
            <Box mt={2}>
              <Typography variant="h6">{message}</Typography>
            </Box>
          </>
        ) : (
          <>
            <Box mt={2}>
              <Typography variant="h6">{message}</Typography>
              <Typography variant="body2" color="textSecondary">
                You can close this tab and try the link again. If the issue persists, please contact support.
              </Typography>
            </Box>
          </>
        )}
      </Box>
    </Container>
  )
}

export default ScopeCheckoutRedirect
